import React from 'react'
import { Create } from 'react-admin'
import { withStyles } from '@material-ui/core/styles'

import GenericForm from './GenericForm'

const styles = {
    card : {
        backgroundColor : '#fff',
    }
}

const CreateForm = (props) =>  (
    <GenericForm
        inputs={props.inputs}
        schema={props.schema}
        permissions={props.permissions}
        edit={false}
        redirect="show"
        {...props}/>
)

const GenericCreate = (props) => {
    const { classes } = props
    if (props.inputs.length === 0) {
        return null
    }
    return (
        <Create classes={classes} {...props}>
            <CreateForm inputs={props.inputs} schema={props.schema} permissions={props.permissions}/>
        </Create>
    )
}

export default withStyles(styles)(GenericCreate)
